import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InfoFormComponent } from './info-form/info-form.component';
import { InfoComponent } from './info.component';

// /user
const routes: Routes = [
  { path: '', component: InfoComponent },
  { path: 'add', component: InfoFormComponent },
  { path: 'edit/:id', component: InfoFormComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InfoRoutingModule { }
